import { useSelector } from "react-redux";
import { getLang } from "../redux/selectors";

export const Notice = () => {
  const lang = useSelector(getLang);
  const text = {
    en: {
      title: "Notice: ",
      paragraphs: [
        "Some handmade items may be temporarily unavailable.",
        "We'll confirm availability and final cost before processing.",
      ],
    },
    ua: {
      title: "Увага: ",
      paragraphs: [
        "Деякі товари можуть бути тимчасово недоступні.",
        "Ми підтвердимо наявність і вартість перед оформленням.",
      ],
    },
  };

  return (
    <div className="md:w-fit mx-auto border-2 border-mainRed text-xs md:text-base">
      <h2 className="bg-mainRed text-gray-200 uppercase ">
        {text[lang].title}
      </h2>
      {text[lang].paragraphs.map((el, index) => (
        <p key={index} className="text-gray-500 p-[0.125rem] md:px-4">
          {el}
        </p>
      ))}
    </div>
  );
};
